<template>
    <InfiniteList
        class="overflow-x-hidden transition-all duration-200"
        :items="options"
        :has-more="true"
        @load-more="$emit('load-more')"
    >
        <template #item="{ item }">
            <div
                :key="item.id"
                class="flex cursor-pointer items-center border-b border-neutral-lighter/50 px-2 py-1.5 transition-colors hover:bg-primary-lightest"
                :class="value.includes(item.id) ? 'bg-primary-lightest' : ''"
                @click="toggleOption(item.id)"
            >
                <div
                    class="relative mr-2 h-5 w-5 flex-none cursor-pointer rounded border border-neutral-lighter transition-all duration-200"
                    :class="{
                        'border-primary bg-primary': value.includes(item.id),
                    }"
                >
                    <Icon
                        :icon="['far', 'check']"
                        class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-xs text-transparent"
                        :class="{
                            'text-white': value.includes(item.id),
                        }"
                    />
                </div>
                <slot v-bind="item">
                    <span>{{ item[label || 'label'] }}</span>
                </slot>
            </div>
        </template>

        <template #empty>
            <div>{{ placeholder }}</div>
        </template>

        <template #loading><div class="hidden" /></template>
    </InfiniteList>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { VALIDATION_REMOVE_ERROR } from '@/constants';
import InfiniteList from '@/components/general/InfiniteList.vue';

@Component({
    components: {
        InfiniteList,
    },
    props: {
        name: String,
        options: Array,
        label: String,
        placeholder: {
            default: 'No options to select from.',
            type: String,
        },
        scope: {
            default: 'default',
            type: String,
        },
        truncate: {
            type: Boolean,
            required: false,
            default: true,
        },
        value: { type: Array, default: () => [] },
    },
})
export default class InputSelectList extends Vue {
    focused = false;

    toggleOption(id) {
        if (this.$store.getters.hasError(this.name, this.scope)) {
            this.$store.commit(VALIDATION_REMOVE_ERROR, {
                field: this.name,
                scope: this.scope,
            });
        }

        if (this.value.includes(id)) {
            this.$emit(
                'input',
                this.value.filter((v) => v !== id),
            );
        } else {
            this.$emit('input', [...this.value, id]);
        }
    }
}
</script>
